import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  applyInsuranceLabel: {
    defaultMessage: 'Apply insurance:',
    description: 'Label for the insurance preference radio section',
    id: 'HAl2Pv',
  },
  insureAllTitle: {
    defaultMessage: 'Automatically insure all shipments',
    description: 'Radio option to automatically insure all shipments',
    id: '0CYxKm',
  },
  insureAllDescription: {
    defaultMessage: 'All shipments are insured based on the total value of the shipment.',
    description: 'Description shown when insure all option is selected',
    id: '3etmYn',
  },
  recommendedBadge: {
    defaultMessage: 'Recommended',
    description: 'Badge text for the recommended insurance option',
    id: '7ce3b+',
  },
  insureByRulesTitle: {
    defaultMessage: 'Automatically insure shipments based on specific rules',
    description: 'Radio option to insure shipments based on custom rules',
    id: 'Jh+YFJ',
  },
  insureSkipTitle: {
    defaultMessage: 'I do not want to automatically insure shipments',
    description: 'Radio option to skip automatic insurance',
    id: 'unZHEE',
  },
  activeParcelGuardRulesBannerTitle: {
    defaultMessage: 'One or more automation rules are currently active',
    id: 'RCu5Py',
    description: 'Info banner title shown on the Insurance settings page when an active ParcelGuard automation rule exists',
  },
  activeParcelGuardRulesBannerBody: {
    defaultMessage:
      'Your active rules will continue to apply insurance to matching shipments regardless of the setting you choose below. <a>Manage rules</a>',
    id: 'f7EugE',
    description: 'Info banner body shown on the Insurance settings page when an active ParcelGuard automation rule exists',
  },
  skipWithActiveRulesWarning: {
    defaultMessage:
      'Without our coverage, you may face costs for lost or damaged shipments. Your active automation rule(s) will still apply insurance to matching shipments unless manually disabled.',
    id: 'r6lXCd',
    description: 'Warning banner shown when the seller selects Do not insure while an active automation rule exists',
  },
  noCoverageWarning: {
    defaultMessage: 'Without our coverage, you may face costs for lost or damaged shipments.',
    description: 'Warning banner shown when the seller has never configured an insurance preference',
    id: '6Qa9gW',
  },
});
